<template>
  <div class="plan-info">
    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Creator Visits</div>

      <div class="plan-info-section__text">
        <template v-if="subscriptionNameLowerCased.includes('starter') || subscriptionNameLowerCased.includes('excursion')">
          <b>{{ props.totalCollabsForYearlySubscription }}</b> {{ `Creator Visit${props.totalCollabsForYearlySubscription > 1 ? "s" : ""}` }} + the Shrpa Platform subscription
        </template>

        <template v-if="subscriptionNameLowerCased.includes('weekender')">
          <b>{{ props.totalCollabsForYearlySubscription }}</b> {{ `Creator Visit${props.totalCollabsForYearlySubscription > 1 ? "s" : ""}` }} + the Shrpa Platform subscription + Priority Support
        </template>

        <template v-if="subscriptionNameLowerCased.includes('destination')">
          <b>{{ props.totalCollabsForYearlySubscription }}</b> {{ `Creator Visit${props.totalCollabsForYearlySubscription > 1 ? "s" : ""}` }} + 1 year of the Shrpa Platform + Premium Support +
          Concierge
        </template>
      </div>
    </div>
    <!-- / Plan info section -->

    <div class="plan-info__divider"></div>

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Creator Visits</div>
      <div class="plan-info-section__text">Work with trusted creators who visit your destination and deliver content for your marketing.</div>
    </div>
    <!-- / Plan info section -->

    <div class="plan-info__divider"></div>

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Community Uploads</div>
      <div class="plan-info-section__text">Let your community upload photos directly into your library for easy use across channels.</div>
    </div>
    <!-- / Plan info section -->

    <div class="plan-info__divider"></div>

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Website Enhancements</div>
      <div class="plan-info-section__text">
        <p class="global-p">Inspire your visitors with amazing UGC photos and videos on your website.</p>
      </div>
    </div>
    <!-- / Plan info section -->

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Dedicated Support</div>
      <div class="plan-info-section__text">
        <p class="global-p">Get expert support to set up Shrpa Platform and ensure smooth, successful Creator Visits.</p>
      </div>
    </div>
    <!-- / Plan info section -->
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    totalCollabsForYearlySubscription: number;
    subscriptionName: string;
  }>(),
  {
    totalCollabsForYearlySubscription: 0,
    subscriptionName: "",
  }
);

// Subscription name lowerCased ===============================================
const subscriptionNameLowerCased = computed<string>(() => props.subscriptionName.toLowerCase());
</script>

<style scoped lang="scss">
@import "./plan-info.scss";
</style>
